import * as angular from "angular";
import {IController} from "angular";

export class BringozSaveFooterComponent implements IController {
  onSave: Function;

  constructor() {
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozSaveFooter', {
    bindings: {
      onSave: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-save-footer/bringoz-save-footer.html',
    controller: BringozSaveFooterComponent
  });
